// ContactCards.jsx
import React from 'react';
import './ContactCards.css';

const ContactCards = () => {
  const contactCards = [
    {
      image: "/images/ceo.png",
      name: "Hussain Mehmood",
      phone: "03008117896",
      position: "CEO",
      loading: "lazy"
    },
    {
      image: "/images/user.png",
      name: "Gladious Connect",
      phone: "03008117896",
      position: "gladiouscontrction@gmail.com"
    },
    {
      image: "/images/user.png",
      name: "Rental Affairs Office",
      phone: "0328-6506281",
      position: "gladiouscontrction@gmail.com"
    },
    {
      image: "/images/user.png",
      name: "Residential Projects Office",
      phone: "0328-6506282",
      position: "gladiouscontrction@gmail.com"
    },
    {
      image: "/images/user.png",
      name: "Land Acquisition Office",
      phone: "0328-6506281",
      position: "gladiouscontrction@gmail.com"
    }
  ];

  return (
    <div className="cards-section">
      <div className="container">
        <h2 
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Our Team
        </h2>
        
        <div 
          className="cards-container"
          initial="offscreen"
          whileInView="onscreen"
          variants={containerVariants}
        >
          <div className="cards-wrapper">
            {contactCards.map((card, index) => (
              <div 
                key={index} 
                className="contact-card"
              >
                <div className="card-image-wrapper">
                  <img src={card.image} alt="card-image" />
                </div>
                <div className="card-content">
                <div className="card-details">
                  <h5 className="card-name">{card.name}</h5>
                    <p className='card-position'>{card.position}</p>
                  <div className="card-contact">
                    <div className="card-contact-phone">
                    <p>{card.phone}</p>
                    </div>
                    <div className="card-contact-symbol">
                      @
                    </div>
                  </div>
                </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCards;

// ====== Animation Variants ======

const containerVariants = {
  offscreen: {},
  onscreen: {
    transition: {
      staggerChildren: 0.15, // delay between cards
    },
  },
};

